import { Howl } from 'howler';
let dropTickSource, positiveWinSoundSource, firstDropSource;
import { path } from "./settings.js";
import store from 'redux-store/store.js';

export function loadSounds () {
  firstDropSource = new Howl({
    src: [path.audioPath + 'first-drop.wav'],
    volume: 1
  });

  dropTickSource = new Howl({
    src: [path.audioPath + 'progressive-tick.wav'],
    volume: 1
  });

  positiveWinSoundSource = new Howl({
    src: [path.audioPath + 'win-sound.wav'],
    volume: 1
  });

  console.log("Audio Loaded");
}

export function playFirstDropSound () {
  const gameSound = store.getState()?.gameSetting.gameSound
  gameSound && firstDropSource.play();
}

export function playDropTickSound () {
  const gameSound = store.getState()?.gameSetting.gameSound
  gameSound && dropTickSource.play();
}

export function playPositiveWinSound () {
  const gameSound = store.getState()?.gameSetting.gameSound
  gameSound && positiveWinSoundSource.play();
}

export function VolumeController (volume) {
  if(dropTickSource && positiveWinSoundSource && firstDropSource) {
    firstDropSource.volume(volume);
    dropTickSource.volume(volume);
    positiveWinSoundSource.volume(volume);
  }
}
